import * as React from 'react';
import classnames from 'classnames';
import { Link, Modal } from '@grandvisionhq/common';
import { Icon } from '@grandvisionhq/icons';

const UspGroupItem = ({ item , className  })=>{
    const [openModal, setOpenModal] = React.useState(false);
    const { icon , text , popupConfig , url  } = item;
    const classNames = classnames('usp-group-item', className);
    const isPopupEnabled = popupConfig && popupConfig.content && popupConfig.title;
    const content = /*#__PURE__*/ React.createElement(React.Fragment, null, icon && /*#__PURE__*/ React.createElement("span", {
        className: "usp-group-item__icon"
    }, /*#__PURE__*/ React.createElement(Icon, {
        name: icon,
        width: 18,
        height: 18
    })), /*#__PURE__*/ React.createElement("span", {
        className: "usp-group-item__message"
    }, text));
    return /*#__PURE__*/ React.createElement(React.Fragment, null, url || isPopupEnabled ? /*#__PURE__*/ React.createElement(Link, {
        url: url,
        className: classNames,
        onClick: ()=>{
            isPopupEnabled && setOpenModal(true);
        }
    }, content) : /*#__PURE__*/ React.createElement("div", {
        className: classNames
    }, content), isPopupEnabled && openModal && /*#__PURE__*/ React.createElement(Modal, {
        children: popupConfig.content,
        className: "usp-group-item__modal",
        isOpen: openModal,
        showIcon: true,
        title: popupConfig.title,
        onModalClose: ()=>setOpenModal(false)
    }));
};

export { UspGroupItem, UspGroupItem as default };
//# sourceMappingURL=UspGroupItem.js.map
